module.exports = __webpack_public_path__ + "static/media/banner-placeholder.7718b2b3.png";